<template>
  <CModal
    class="modal__footer-empty"
    :title="title"
    centered
    :show="show"
    :close-on-backdrop="false"
    @update:show="closeModal"
  >
    <VCreateUserForm
      v-if="showForm"
      :user="selectedUser"
      @success="onSuccess"
    />
  </CModal>
</template>
<script>
import VCreateUserForm from "@/components/Forms/VCreateUserForm";
import { modalStore } from "@/mixins/modalsMixin";
import { getUser } from "@/utils/validation/user";
import {
  createAuthStoreMixin,
  authStore,
} from '@/mixins/authStoreMixin'

export default {
  name: "TheCreateUserModal",

  mixins: [createAuthStoreMixin()],

  components: {
    VCreateUserForm
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showForm: true
  }),

  computed: {
    currentUser() {
      return this[authStore.getterTypes.GETTER_USER]
    },
    selectedUser() {
      const rawUser = this.$store.getters[
        `${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`
      ];
      return rawUser && rawUser.user_id ? getUser(rawUser) : rawUser;
    },
    title() {
      return this.selectedUser && this.selectedUser.id ? 'Edit user' : 'Create user'
    }
  },

  methods: {
    closeModal() {
      this.$store.dispatch(
        `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
        null
      );
      this.$emit("close");
    },

    onSuccess(isNewUser) {
      if (isNewUser) {
        this.$router.push({ query: "" });
      }

      this.closeModal();
    }
  }
};
</script>
